module.exports = __webpack_public_path__ + "static/img/choice_checked.2378fb97.svg";